export default [
  {
    path: "/",
    name: "default",
    meta: { title: "Dashboard", authRequired: true },
    component: () => import("@/views/dashboard/ecommerce/index.vue"),
  },
  {
    path: "/delivery-schedule",
    name: "delivery-schedule",
    meta: {
      title: "Tiến Độ Sản Xuất",
      authRequired: true,
      requiresDeliverySchedule: true,
    },
    component: () => import("@/views/delivery-schedule/DeliverySchedulePage.vue"),
  },
  {
    path: "/dashboard/staff",
    name: "staff-dashboard",
    meta: { title: "Thống Kê Nhân Viên", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/dashboard/staff/index.vue"),
  },
  {
    path: "/demo/:orderCode",
    name: "demo-preview",
    component: () => import("@/views/demo/DemoPreviewPage.vue"),
    meta: { title: "Xem ảnh demo" },
  },
  {
    // Công khai — nhân viên quét QR dán cạnh máy in, nhập mã đơn để in phiếu (?t=).
    // Có trong SHARED_ROUTE_PREFIXES (roles.cjs) để quản đốc đang đăng nhập vẫn vào được.
    path: "/in-phieu",
    name: "qr-print",
    component: () => import("@/views/print-station/QrPrintPage.vue"),
    meta: { title: "In phiếu" },
  },
  {
    // Công khai — thợ quét QR hoàn thành SX: tick đơn Đang SX → Hoàn thành SX (?t=).
    // Có trong SHARED_ROUTE_PREFIXES (roles.cjs) như /in-phieu.
    path: "/hoan-thanh-sx",
    name: "factory-complete",
    component: () => import("@/views/factory-qr/FactoryCompletePage.vue"),
    meta: { title: "Hoàn thành sản xuất" },
  },
  {
    // Công khai — thợ may quét QR xem đơn đang sản xuất (token trong query ?t=)
    path: "/production-board",
    name: "production-board",
    component: () => import("@/views/production-board/ProductionBoardPage.vue"),
    meta: { title: "Đơn đang sản xuất" },
  },
  {
    // Công khai — màn hình TV realtime treo ở xưởng (token trong query ?t=)
    path: "/tv-dashboard",
    name: "tv-dashboard",
    component: () => import("@/views/tv-dashboard/TvDashboardPage.vue"),
    meta: { title: "Màn hình TV — Mizo Sport" },
  },

  // Ecommerce
  {
    path: "/ecommerce/customers",
    name: "customers",
    meta: { title: "Customers", authRequired: true },
    component: () => import("@/views/apps/ecommerce/customers"),
  },
  {
    path: "/ecommerce/customer-details/:id",
    name: "customer-detail",
    meta: { title: "Chi Tiết Khách Hàng", authRequired: true },
    component: () => import("@/views/apps/ecommerce/customer-details"),
  },
  {
    path: "/ecommerce/staff",
    name: "staff",
    meta: { title: "Staff", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/staff"),
  },
  {
    path: "/ecommerce/audit-logs",
    name: "audit-logs",
    // Chỉ super_admin (`requiresAuditLog`) — admin thường KHÔNG vào, xem AUDIT_LOG_ROLES.
    meta: { title: "Nhật Ký Hoạt Động", authRequired: true, requiresAuditLog: true },
    component: () => import("@/views/apps/ecommerce/audit-logs"),
  },
  {
    // Đã gộp thành tab trong Cài đặt (chỉ super_admin thấy tab) — giữ link cũ.
    path: "/ecommerce/integrations",
    redirect: { path: "/ecommerce/settings", query: { tab: "integrations" } },
  },
  {
    path: "/ecommerce/products",
    name: "products",
    meta: { title: "Products", authRequired: true },
    component: () => import("@/views/apps/ecommerce/products"),
  },
  {
    // Thư viện file rập: admin/super_admin quản lý, staff chỉ xem + tải. Ghi bị chặn
    // ở backend (require_admin); trang tự ẩn nút ghi theo role.
    path: "/ecommerce/patterns",
    name: "patterns",
    meta: { title: "File Rập", authRequired: true },
    component: () => import("@/views/apps/ecommerce/patterns.vue"),
  },
  {
    path: "/ecommerce/product-details/:id",
    name: "product-detail",
    meta: { title: "Product Details", authRequired: true },
    component: () => import("@/views/apps/ecommerce/product-details"),
  },
  {
    // Khai báo CTV + khoá API của site CTV — dữ liệu nhạy cảm nên chỉ admin,
    // gương của `require_admin` trên toàn bộ router /partners ở backend.
    path: "/ecommerce/partners",
    name: "partners",
    meta: { title: "Cộng Tác Viên", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/partners"),
  },
  {
    // Bảng giá sỉ của MỘT CTV — cùng quyền với trang CTV (backend: require_admin).
    path: "/ecommerce/partners/:partnerId/prices",
    name: "partner-prices",
    meta: { title: "Bảng Giá Sỉ CTV", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/partner-prices.vue"),
  },
  {
    path: "/ecommerce/carriers",
    name: "carriers",
    meta: { title: "Đơn Vị Vận Chuyển", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/carriers"),
  },

  // Orders
  {
    path: "/ecommerce/orders",
    name: "orders",
    meta: { title: "Orders", authRequired: true },
    component: () => import("@/views/apps/ecommerce/order/orders"),
  },
  {
    path: "/ecommerce/order-notes",
    name: "order-notes",
    meta: { title: "Ghi chú đơn hàng", authRequired: true },
    component: () => import("@/views/apps/ecommerce/order/order-notes"),
  },
  {
    path: "/ecommerce/add-order",
    name: "add-order",
    meta: { title: "Tạo Đơn Hàng", authRequired: true },
    component: () => import("@/views/apps/ecommerce/order/OrderFormPage"),
  },
  {
    path: "/ecommerce/edit-order/:id",
    name: "edit-order",
    meta: { title: "Sửa Đơn Hàng", authRequired: true },
    component: () => import("@/views/apps/ecommerce/order/OrderFormPage"),
  },
  {
    path: "/ecommerce/order-details",
    redirect: "/ecommerce/orders",
  },
  {
    path: "/ecommerce/order-details/:id",
    name: "order-details",
    meta: { title: "Order Details", authRequired: true },
    component: () => import("@/views/apps/ecommerce/order/order-details"),
  },
  // Trang cũ đã gộp vào tab "Mẫu tin nhắn" (03/11) — giữ redirect cho bookmark/link cũ.
  {
    path: "/ecommerce/order-message-templates",
    redirect: { path: "/zalo/groups", query: { tab: "templates" } },
  },

  // Products CRUD
  {
    path: "/ecommerce/add-product",
    name: "add-product",
    // Bảng giá là việc của admin: trang này ghi `Product.price`, backend đã khoá
    // `POST /products` về require_admin nên vào được cũng chỉ nhận 403 khi bấm Lưu.
    meta: { title: "Create Product", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/add-product"),
  },
  {
    path: "/ecommerce/edit-product/:id",
    name: "edit-product",
    meta: { title: "Edit Product", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/add-product"),
  },
  {
    path: "/ecommerce/settings",
    name: "ecommerce-settings",
    meta: { title: "Settings", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/checkout"),
  },

  // Zalo
  {
    // Bảng ticket chăm sóc khách: sale thấy ticket của mình, admin thấy hết.
    // `requiresSales` = SALES_ROLES, gương `require_sales_or_admin` của API /zalo/care.
    path: "/zalo/care",
    name: "zalo-care",
    // keepScrollOnQuery: mở/đóng ticket đổi ?ticket=, không được cuộn bảng lên đầu.
    meta: { title: "Chăm Sóc Khách", authRequired: true, requiresSales: true, keepScrollOnQuery: true },
    component: () => import("@/views/apps/ecommerce/zalo-care.vue"),
  },
  {
    path: "/zalo/response-time",
    name: "zalo-response-time",
    meta: { title: "Thống Kê Phản Hồi Khách Hàng", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/zalo-response-time.vue"),
  },
  {
    path: "/zalo/groups",
    name: "zalo-groups",
    meta: { title: "Zalo", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/zalo/ZaloPage.vue"),
  },
  {
    path: "/zalo/groups/:id",
    name: "zalo-group-detail",
    meta: { title: "Zalo Group Detail", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/zalo-group-detail"),
  },

  // Đánh giá của khách
  {
    path: "/ecommerce/reviews",
    name: "ecommerce-reviews",
    meta: { title: "Đánh giá", authRequired: true },
    component: () => import("@/views/apps/ecommerce/reviews"),
  },

  // Công nợ KH + thanh toán đơn: `requiresReceivables` (RECEIVABLE_ROLES — có thư ký).
  // Hai route NCC bên dưới giữ `requiresAccounting` (ACCOUNTING_ROLES — không thư ký).
  {
    path: "/accounting/receivables",
    name: "accounting-receivables",
    meta: { title: "Công Nợ Khách Hàng", authRequired: true, requiresReceivables: true },
    component: () => import("@/views/apps/accounting/receivables.vue"),
  },
  {
    path: "/accounting/order-payments",
    name: "accounting-order-payments",
    meta: { title: "Thanh Toán Đơn Hàng", authRequired: true, requiresReceivables: true },
    component: () => import("@/views/apps/accounting/order-payments.vue"),
  },
  {
    path: "/accounting/payables",
    name: "accounting-payables",
    meta: { title: "Công Nợ Nhà Cung Cấp", authRequired: true, requiresAccounting: true },
    component: () => import("@/views/apps/accounting/payables.vue"),
  },
  {
    path: "/accounting/suppliers",
    name: "accounting-suppliers",
    meta: { title: "Nhà Cung Cấp", authRequired: true, requiresAccounting: true },
    component: () => import("@/views/apps/accounting/suppliers.vue"),
  },

  // Công nợ cộng tác viên — CHỈ thư ký (`requiresPartnerDebt`, allow-list KHÔNG có
  // admin). Đặt ở "/partner-debts" chứ không lồng trong "/accounting/" vì kế toán bị
  // khoá trong đúng vùng đó: nằm chung đường dẫn là kế toán đi lạc vào được menu này.
  {
    path: "/partner-debts",
    name: "partner-debts",
    meta: { title: "Công Nợ CTV", authRequired: true, requiresPartnerDebt: true },
    component: () => import("@/views/apps/ecommerce/partner-debts.vue"),
  },
  // Tổng quan CTV — cùng allow-list với công nợ CTV. Cố ý nằm DƯỚI "/partner-debts":
  // thư ký bị `confinedRedirect` khoá trong đúng prefix đó, đặt ở "/dashboard/..." là
  // thư ký bấm menu bị đá ngược về trang công nợ. Đoạn tĩnh "overview" được vue-router
  // xếp hạng trên ":partnerId" nên không bị route chi tiết bên dưới nuốt.
  {
    path: "/partner-debts/overview",
    name: "partner-dashboard",
    meta: { title: "Tổng Quan CTV", authRequired: true, requiresPartnerDebt: true },
    component: () => import("@/views/dashboard/partners/index.vue"),
  },
  {
    path: "/partner-debts/:partnerId",
    name: "partner-debt-detail",
    meta: { title: "Công Nợ Cộng Tác Viên", authRequired: true, requiresPartnerDebt: true },
    component: () => import("@/views/apps/ecommerce/partner-debt-detail.vue"),
  },

  // Công nợ khách riêng — CHỈ super_admin (`requiresPrivateDebt`, backend PRIVATE_DEBT_ROLES).
  // Route top-level: lồng dưới "/accounting/" là lọt vào vùng khoá của kế toán, lồng
  // dưới "/ecommerce/customers/" là lẫn với khu danh sách khách của nhân viên.
  {
    path: "/private-debts",
    name: "private-debts",
    meta: { title: "Công Nợ Khách Riêng", authRequired: true, requiresPrivateDebt: true },
    component: () => import("@/views/apps/ecommerce/private-debts.vue"),
  },
  {
    path: "/private-debts/:customerId",
    name: "private-debt-detail",
    meta: { title: "Công Nợ Khách Riêng", authRequired: true, requiresPrivateDebt: true },
    component: () => import("@/views/apps/ecommerce/private-debt-detail.vue"),
  },

  // Account
  {
    path: "/pages/profile-setting",
    name: "profile-setting",
    meta: { title: "Setting", authRequired: true },
    component: () => import("@/views/pages/profile/setting"),
  },
];
